import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import {
//   doGetRasterRecord
//   // updateSingleDevicePageSelectedRasterId,
//   // updateSingleDevicePageSelectedBeamRankIdx,
//   // updateSingleDevicePageSelectedRasterRecord
// } from 'redux/actions';
// import { Status } from 'common/utils/constants';
import './ActionTwoHopProgressTableRow.css';

const ActionTwoHopProgressTableRow = (props) => {
  let className = 'rt-tr';
  const dispatch = useDispatch();
  // const selectedDeviceHeatmapRasterId = useSelector((store) => store.ui.singleDevicePage?.heatmap?.selectedRasterId);

  // const getRasterRecordStatusName = `GET-RasterRecord-${selectedDeviceHeatmapRasterId}`;
  // const getRasterRecordStatus = useSelector((store) => store.statuses[getRasterRecordStatusName]);

  let original = props.children[0].props.children.props && props.children[0].props.children.props.original;
  let rasterId = original?.rasterId;
  let deviceId = original?.deviceId;

  // const deviceHeatmapHistoryDictionary = useSelector((store) => store.data.heatmapHistoryDictionary?.[deviceId] ?? {});
  // const getRasterRecordStatusName2 = `GET-RasterRecord-${rasterId}`;
  // const getRasterRecordStatus2 = useSelector((store) => store.statuses[getRasterRecordStatusName2]);

  // const selectedRastersDictionary = useSelector((store) => store.ui.singleDevicePage.heatmap.selectedRastersDictionary);

  // let numOfSelectedRasters = 0;
  // selectedRastersDictionary &&
  //   Object.keys(selectedRastersDictionary).forEach((rasterId) => {
  //     if (selectedRastersDictionary[rasterId] === true) numOfSelectedRasters += 1;
  //   });

  // let isSelected = rasterId && selectedRastersDictionary?.[rasterId];

  // if (rasterId) {
  //   className +=
  //     selectedDeviceHeatmapRasterId === rasterId
  //       ? ' ActionTwoHopProgressTableRow_Selected'
  //       : ' ActionTwoHopProgressTableRow_Not_Selected';
  // }

  // if (
  //   getRasterRecordStatus === Status.PENDING ||
  //   getRasterRecordStatus2 === Status.PENDING ||
  //   (isSelected === false && numOfSelectedRasters >= 2)
  // ) {
  //   className += ' ActionTwoHopProgressTableRow_Loading';
  // }

  // const handleRowClick = () => {
  //   let record = deviceHeatmapHistoryDictionary?.[rasterId];

  //   if (record && deviceId && rasterId) {
  //     // dispatch(updateSingleDevicePageSelectedRasterId(rasterId));
  //     let cb_success = (record) => {
  //       // dispatch(updateSingleDevicePageSelectedRasterRecord(record));
  //       // record?.beamrank && dispatch(updateSingleDevicePageSelectedBeamRankIdx(1));
  //     };
  //     if (!record.heatmap) {
  //       dispatch(doGetRasterRecord(deviceId, rasterId, cb_success));
  //     } else {
  //       // dispatch(updateSingleDevicePageSelectedRasterRecord(record));
  //       // record?.beamrank && dispatch(updateSingleDevicePageSelectedBeamRankIdx(1));
  //     }
  //   }
  // };

  return (
    <div
      id={className}
      className={className}
      onClick={() => {
        // handleRowClick();
      }}
    >
      {props.children}
    </div>
  );
};

export default ActionTwoHopProgressTableRow;
